import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar as faStarFull,
  faStar as faStarEmpty,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";
import defaultfullbanner from "../Component/img/event1.jfif";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const AllreviewComp = ({ eventUniqueId }) => {
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  const [visitorId, setVisitorId] = useState(
    localStorage.getItem("visitor_id")
  );
  const [reviews, setReviews] = useState([]);
  const [notification, setNotification] = useState(""); // Add notification state
  const navigate = useNavigate();

  const handleRatingClick = (value) => {
    setRating(value);
  };

  const handleReviewChange = (e) => {
    setReview(e.target.value);
  };

  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => setNotification(""), 3000); // Hide after 3 seconds
  };

  //   console.log("eventUniqueId : ",eventUniqueId);
  const handleSubmit = async () => {
    // console.log("eventUniqueId : ",eventUniqueId);

    // console.log("Data being sent:", {
    //     user_id: visitorId,
    //     event_id: eventUniqueId,
    //     rating: rating,
    //     review_text: review,
    //   });

    try {
      const response = await axios.post(`${BASE_URL}insertReview`, {
        user_id: visitorId,
        event_id: eventUniqueId,
        rating: rating,
        review_text: review,
      });

      if (response.data) {
        setRating(0);
        setReview("");
        showNotification("Review submitted successfully!");
        fetchReviews(); // Fetch reviews after successful submission
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        showNotification("Already Rated this event");
      } else {
        console.error("Error submitting review:", error);
      }
    }
  };

  const handleTextareaClick = () => {
    if (!visitorId) {
      const currentUrl = `${window.location.href}#review`;
      localStorage.setItem("redirectUrl", currentUrl);
      navigate("/login");
    }
  };

  const fetchReviews = async () => {
    // console.log("Running API...");
    try {
      const response = await axios.get(
        `${BASE_URL}fetchReviewsByEventIdAll/${eventUniqueId}`
      );

      // Log the entire response for debugging
      // console.log("API Response:", response);

      if (response.data && response.data.data) {
        // console.log("Reviews fetched:", response.data.data);
        setReviews(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, [eventUniqueId]);

  const sortedReviews = () => {
    const highRatings = reviews.filter((review) => review.rating >= 4);
    const lowRatings = reviews.filter((review) => review.rating < 4);
    return [...highRatings, ...lowRatings].slice(0, 15);
  };

  return (
    <>
      {/* Notification */}
      {notification && <div className="notification">{notification}</div>}

      <div className="mt-3 bg-white rounded mb-3 p-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div>
            <h2 className="h3clsss text-start mb-2">Review & Rating</h2>
          </div> 
        </div>

        <hr className="mb-2" />

     
        {/* Display User Reviews */}
        <div className="eventcard_container bg-salt mb-3 p-2 bdrds mt-3">
          <div className="head-label py-2  text-start">
            {/* <h2 className="h3clsss text-start mb-2">User Reviews</h2> */}
            {sortedReviews().length > 0 ? (
              sortedReviews().map((review, index) => (
                <div className="row mb-2" key={review.id || index}>
                  <div className="">
                     <div className="d-flex align-items-center justify-content-between">
                                          <div className="d-flex align-items-center">
                                            <span>
                                              <FontAwesomeIcon
                                                icon={faUserCircle}
                                                className="text-muted ft11"
                                              />
                                            </span>
                                            <span className="mx-2">
                                              <span className="ploq2">{review.user_name}</span>
                                            </span>
                                          </div>
                    
                                          <div>
                                            <div className="ftratss text-muted mx-2">
                                              {new Date(review.created_at).toLocaleDateString(
                                                "en-GB",
                                                {
                                                  day: "2-digit",
                                                  month: "short",
                                                  year: "numeric",
                                                }
                                              )}
                                            </div>
                    
                                            <div className="badge ">
                                              {[...Array(5)].map((_, starIndex) => (
                                                <FontAwesomeIcon
                                                  key={starIndex}
                                                  icon={
                                                    review.rating && starIndex < review.rating
                                                      ? faStarFull
                                                      : faStarEmpty
                                                  }
                                                  className={
                                                    review.rating && starIndex < review.rating
                                                      ? "filled-star"
                                                      : "empty-star"
                                                  }
                                                />
                                              ))}
                                            </div>
                                          </div>
                                        </div>

                     
                    <div className="ftratss1">{review.review_text}</div>
                    <hr />
                  </div>
                </div>
              ))
            ) : (
              <div>No reviews available for this event.</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AllreviewComp;
